import $ from "jquery"
import autocomplete from "lib/autocomplete"
import AcademicTitles from "lib/academic_titles"
import BasePage from "pages/base_page"
import ChooserView from "views/chooser_view"

class ProfileInstitutionsPage extends BasePage {
  initialize(options) {
    super.initialize(options)
    this.autocompleteJobTitle()
    this.initInstitutionChooser()
  }

  autocompleteJobTitle() {
    $(".profile_institution_occupation.autocomplete").each(function () {
      return autocomplete($(this), {
        source: AcademicTitles.list,
        minLength: 2,
        autoFocus: true,
        delay: 200,
        select(event, ui) {
          return this.val(ui.item)
        },
      })
    })
  }

  initInstitutionChooser() {
    const hiddenInput = $("#new_profile_institution_institution")
    const container = $("#new_profile_institution_institution_chooser")
    if (hiddenInput.length === 0 || container.length === 0) return

    const chooser = new ChooserView({
      title: container.data("label") || "Institution",
      placeholder: "Select an institution",
      source: "/institutions/search.json",
      clearable: true,
      limit: 20,
    })

    container.empty().append(chooser.$el)
    chooser.on("clear", () => hiddenInput.val(""))
    chooser.on("selected", (item) => hiddenInput.val(item.institution.id))
  }
}

export default ProfileInstitutionsPage
